export default "/images/vendor/flag-icon-css/flags/4x3/td.svg?f6c172d9fdebca34a65fe2355fe4bd47";